import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import ReportDialog from '#component/shipment/overview/report-dialog';
import { openBackdrop, closeBackdrop } from '#action/backdrop';

const StyledIcon = styled(SaveAltRoundedIcon)({
  lineHeight: '1em',
  display: 'inline-block',
  verticalAlign: 'middle'
});

export default props => {
  const [showReportDialog, setReportDialog] = useState(false);
  const dispatch = useDispatch();

  const { shipment: s } = props;

  const delivery = s.delivery || s.states || [];
  const lastState = delivery.length > 1 && delivery[delivery.length - 1];
  const done = s.done && lastState.done;
  const stopped = s.done && !lastState.done;
  const dateRange = [s.startDate, s.endDate];

  const handleDialogOpen = async () => {
    dispatch(openBackdrop());
    await dispatch(closeBackdrop());
    await setReportDialog(true);
  };

  if (!(done || stopped)) {
    return null;
  }

  return (
    <>
      <Tooltip title="Download PDF report">
        <IconButton
          size="small"
          key="close"
          aria-label="Download PDF report"
          color="inherit"
          onClick={async e => {
            e.stopPropagation();
            await handleDialogOpen();
          }}
        >
          <StyledIcon />
        </IconButton>
      </Tooltip>
      <ReportDialog
        showDialog={showReportDialog}
        setReportDialog={setReportDialog}
        dispatch={dispatch}
        dateRange={dateRange}
        {...props}
      />
    </>
  );
};
